import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const BibLevelList = Loadable(
  lazy(() => import("features/biblevel/components/List"))
);
const BibLevelPage = Loadable(
  lazy(() => import("features/biblevel/components/Page"))
);

const routes = {
  path: "biblevel",
  children: [
    { path: "", element: <BibLevelList /> },
    { path: "add", element: <BibLevelPage /> },
    { path: "edit/:biblevelID?", element: <BibLevelPage /> },
  ],
};

export default routes;
